/*
 * Copyright (c) 2023 Bluemate B.V.
 */

let menuWidth: number = 0;

export const setMenuWidth = (width: number) => {
    menuWidth = width;
};

export const getMenuWidth = (): number => menuWidth;
